import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataReservation } from '../../data/DataReservation';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    idLotCommercial
    nbADF
    affichageSignatureClient
    affichageValidationEiffage
    affichageSignatureEiffage
    affichageSignatureActe
    onAffichePanelReservationCycle
    onAnnuleFiche
    onEnregistrementFiche
****************************************************************/

var objetState = {
    reservation: {},
    titrePanelCycle: '',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelCycleReservation: 'Renseigner les cycles de la réservation',

    peutModifierBlocEtat: false,
    peutModifierBlocDateAutre: false,
    activationSignatureClient: false,
    activationValidation: false,
    activationSignatureEiffage: false,
    activationSignatureActe: false
};

export class FicheReservationCycle extends Component {

    _creationContent = () => {

        const { reservation } = this.state;
        const estSigneElectroniqueClient = reservation.dateSignatureElectronique !== null;
        const estSigneElectroniqueEiffage = reservation.dateSignatureEiffageElectronique !== null;
        const dateMaxSignature = new Date(Date.now());

        var objTravailAffichage = {
            fichesKYCEnabled: false,
            ficheInfoPrecontractuelleEnabled: false,
            estValidationEiffageEnabled: false,

            ficheKYCVisible: false,
            ficheInfoPrecontractuelleVisible: false
        };
        const aucunAppelsDeFondsEffectues = (this.props.nbADF == 0);

        FicheReservationCycle._onChargement_KYC_PreContractuelle_ValidationEiffage(reservation, this.state.peutModifierBlocEtat, this.state.activationValidation, objTravailAffichage, aucunAppelsDeFondsEffectues);


        /*const estValidationEiffageDisabled = !this.state.peutModifierBlocEtat // Droits insuffisants
    || !this.state.activationValidation
    || !(reservation.dateSignatureElectronique || reservation.dateDeSignatureManuelle) // Pas de signature client
    || (new Date(reservation.dateReservation) >= new Date(2021, 2, 1) && !(reservation.fichesKyc && reservation.ficheInfoPrecontractuelle)) // A compter de mars 2021 : fiches KYC + info précontractuelle obligatoires
    || this.props.nbADF > 0;*/


        return (
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.state.titrePanelCycleReservation}
                isOpen={this.props.onAffichePanelReservationCycle}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.medium}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">

                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {this.props.affichageSignatureClient &&
                                <div className="ms-Grid-row ligneDatesReservation">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">Date de signature client {(estSigneElectroniqueClient ? '(électronique)' : null)}</div>
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                                        <EUIDatePicker
                                            disabled={!(this.state.peutModifierBlocDateAutre && this.state.activationSignatureClient) || estSigneElectroniqueClient || this.props.nbADF > 0}
                                            allowTextInput={false}
                                            maxDate={dateMaxSignature}
                                            onClear={this._onResetDateDeSignatureClient}
                                            onSelectDate={e => this._onMiseAJourChamp("reservation", "dateDeSignatureManuelle", Scriba.date().getChaineISOFromDate(e))}
                                            placeholder="Selectionnez une date"
                                            value={estSigneElectroniqueClient ? reservation.dateSignatureElectronique : reservation.dateDeSignatureManuelle}
                                        />
                                    </div>
                                </div>
                            }

                            {this.props.affichageValidationEiffage &&
                                <Fragment>
                                    {objTravailAffichage.ficheKYCVisible ?
                                        <div className="ms-Grid-row ligneDatesReservation">
                                            <div className="ms-Grid-col ms-sm12 ms-xl6">Fiche(s) KYC</div>
                                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                                <Toggle
                                                    checked={reservation.fichesKyc}
                                                    disabled={!objTravailAffichage.fichesKYCEnabled}
                                                    inlineLabel
                                                    offText="Non fournie(s)"
                                                    onChange={this._onChangeFiche("fichesKyc")}
                                                    onText="Fournie(s)"
                                                />
                                            </div>
                                        </div>
                                        : null}
                                    {objTravailAffichage.ficheInfoPrecontractuelleVisible ?
                                        <div className="ms-Grid-row ligneDatesReservation">
                                            <div className="ms-Grid-col ms-sm12 ms-xl6">Fiche d'information précontractuelle</div>
                                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                                <Toggle
                                                    checked={reservation.ficheInfoPrecontractuelle}
                                                    disabled={!objTravailAffichage.ficheInfoPrecontractuelleEnabled}
                                                    inlineLabel
                                                    offText="Non fournie"
                                                    onChange={this._onChangeFiche("ficheInfoPrecontractuelle")}
                                                    onText="Fournie"
                                                />
                                            </div>
                                        </div> :
                                        null}
                                    <div className="ms-Grid-row ligneDatesReservation">
                                        <div className="ms-Grid-col ms-sm12 ms-xl6">Validation Eiffage</div>
                                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                                            <Toggle
                                                checked={reservation.validee}
                                                disabled={!objTravailAffichage.estValidationEiffageEnabled}
                                                inlineLabel
                                                offText="Non"
                                                onChange={this._onChangeValidationEiffage}
                                                onText="Oui"
                                            />
                                        </div>
                                    </div>
                                </Fragment>
                            }

                            {this.props.affichageSignatureEiffage &&
                                <div className="ms-Grid-row ligneDatesReservation">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">Date de signature Eiffage {(estSigneElectroniqueEiffage ? '(électronique)' : null)}</div>
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                                        <EUIDatePicker
                                            allowTextInput={false}
                                            disabled={!(this.state.peutModifierBlocDateAutre && this.state.activationSignatureEiffage) || estSigneElectroniqueEiffage || !reservation.validee || this.props.nbADF > 0}
                                            maxDate={dateMaxSignature}
                                            onClear={e => this._onMiseAJourChamp("reservation", "dateDeSignatureEiffageManuelle", null)}
                                            onSelectDate={e => this._onMiseAJourChamp("reservation", "dateDeSignatureEiffageManuelle", Scriba.date().getChaineISOFromDate(e))}
                                            placeholder="Selectionnez une date"
                                            value={estSigneElectroniqueEiffage ? reservation.dateSignatureEiffageElectronique : reservation.dateDeSignatureEiffageManuelle}
                                        />
                                    </div>
                                </div>
                            }

                            {this.props.affichageSignatureActe &&
                                <div className="ms-Grid-row ligneDatesReservation">
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">Date de signature de l'acte</div>
                                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                                        <EUIDatePicker
                                            allowTextInput={false}
                                            disabled={!(this.state.peutModifierBlocDateAutre && this.state.activationSignatureActe) || this.props.nbADF > 0}
                                            maxDate={dateMaxSignature}
                                            onClear={e => this._onMiseAJourChamp("reservation", "dateSignatureActe", null)}
                                            onSelectDate={e => this._onMiseAJourChamp("reservation", "dateSignatureActe", Scriba.date().getChaineISOFromDate(e))}
                                            placeholder="Selectionnez une date"
                                            value={reservation.dateSignatureActe}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit = () => {
        this.setState(objetState);
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement en cours'
        });

        var ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

        ficheReservation_Simple
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.reservation = objetData[0];
                    stateTemp.peutModifierBlocDateAutre = objetData[1];
                    stateTemp.peutModifierBlocEtat = objetData[2];
                    stateTemp.activationSignatureClient = objetData[3];
                    stateTemp.activationValidation = objetData[4];
                    stateTemp.activationSignatureEiffage = objetData[5];
                    stateTemp.activationSignatureActe = objetData[6];

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            if (this.props.affichageSignatureClient) {
                estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateDeSignatureManuelle);
            }
            if (this.props.affichageSignatureEiffage) {
                estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateDeSignatureEiffageManuelle);
            }
            if (this.props.affichageValidationEiffage) {
                estValide = estValide && item.validee;
            }
            if (this.props.affichageSignatureActe) {
                estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateSignatureActe);
            }
        }
        else {
            estValide = false;
        }

        return estValide;
    }

    _onChangeFiche = (fiche) => (e, isChecked) => {
        this.setState(prevState => {
            let reservation = {
                ...prevState.reservation,
                [fiche]: isChecked
            };
            if (!isChecked && new Date(reservation.dateReservation) >= new Date(2021, 2, 1)) {
                reservation.validee = false;
                reservation.dateDeSignatureEiffageManuelle = null;
            }
            return { reservation };
        });
    };

    _onChangeValidationEiffage = (e, isChecked) => {
        let nomProprietes = [["validee", isChecked]];
        if (!isChecked)
            nomProprietes.push(["dateDeSignatureEiffageManuelle", null]);
        Scriba.state().setObjetProprietes(this, "reservation", nomProprietes);
    };

    _onResetDateDeSignatureClient = () => {
        let nomProprietes = [
            ["dateDeSignatureManuelle", null],
            ["validee", false]
        ];
        Scriba.state().setObjetProprietes(this, "reservation", nomProprietes);
    };

    _onEnregistrement = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(
            this.props.idOperation,
            this.props.idReservation,
            this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onRenderFooterContent = () => {
        //let boutonActif = this._validationFormulaire(this.state.reservation);
        //disabled={!boutonActif}
        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px">Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);
    }

    render = () => {
        return this._creationContent();
    }

    static _onChargement_KYC_PreContractuelle_ValidationEiffage(reservation, peutModifierBlocEtat, activationValidation, objTravailAffichage, aucunAppelsDeFondsEffectues) {

        const estSigneClient = (reservation.dateSignatureElectronique != null) || (reservation.dateDeSignatureManuelle != null);

        objTravailAffichage.fichesKYCEnabled = false;
        objTravailAffichage.ficheInfoPrecontractuelleEnabled = false;
        var onPeutActiverValidationEiffage = peutModifierBlocEtat && activationValidation && estSigneClient && aucunAppelsDeFondsEffectues;
        objTravailAffichage.estValidationEiffageEnabled = onPeutActiverValidationEiffage;

        //YD : modification du début de la date à prendre en compte => 01/04/2021 à présent (défini dans la classe réservation)
        if (new Date(reservation.dateReservation) >= new Date(reservation.dateDebutPriseEnChargeFichesKYC_Et_FicheInfoPrecontractuelle)) {    //new Date(2021, 3, 1)) {
            objTravailAffichage.estValidationEiffageEnabled = onPeutActiverValidationEiffage && reservation.fichesKyc && reservation.ficheInfoPrecontractuelle;
            objTravailAffichage.fichesKYCEnabled = onPeutActiverValidationEiffage && !reservation.validee;
            objTravailAffichage.ficheInfoPrecontractuelleEnabled = onPeutActiverValidationEiffage && !reservation.validee;

            objTravailAffichage.ficheKYCVisible = true;
            objTravailAffichage.ficheInfoPrecontractuelleVisible = true;
        }
    }
}